const likeTabLinkFixedPointTrigger = document.getElementById("js-likeTabLinkFixedPoint"); // id="js-likeTabLinkFixedPoint"の要素を取得

if (likeTabLinkFixedPointTrigger) {
  // スクロール時に実行される関数
  function handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;

    // .c-likeTabLinkが存在する場合のみ要素を取得
    const elementToFix = document.querySelector(".c-likeTabLink");

    if (elementToFix) {
      const triggerOffset = likeTabLinkFixedPointTrigger.getBoundingClientRect().bottom; // id="js-likeTabLinkFixedPoint"の下端位置を取得

      // スクロール位置がid="js-likeTabLinkFixedPoint"の下端位置に達したら
      if (scrollY >= triggerOffset) {
        elementToFix.classList.add("js-likeTabLinkFixed");
      } else {
        // スクロール位置が条件を満たさない場合はクラスを削除
        elementToFix.classList.remove("js-likeTabLinkFixed");
      }
    }
  }

  // スクロールイベントを監視
  window.addEventListener("scroll", handleScroll);
}
